<template>
    <div>
        <div class="my-4 flex flex-wrap items-center gap-4">
            <div class="flex-1 min-w-[200px]">
                <input
                    v-model="filters.search"
                    type="text"
                    placeholder="Buscar por nome ou email..."
                    class="w-full rounded-lg border border-gray-300 bg-gray-50 p-2 text-sm dark:border-gray-600 dark:bg-gray-700 dark:text-white"
                    @keyup.enter="resetAndFetch"
                />
            </div>
            <div class="min-w-[200px]">
                <select
                    v-model="filters.manager_uuid"
                    class="w-full rounded-lg border border-gray-300 bg-gray-50 p-2 text-sm dark:border-gray-600 dark:bg-gray-700 dark:text-white"
                    @change="resetAndFetch"
                >
                    <option :value="null">Todos os Gerentes</option>
                    <option
                        v-for="manager in managers"
                        :key="manager.uuid"
                        :value="manager.uuid"
                    >
                        {{ manager.name }}
                    </option>
                </select>
            </div>
            <button
                @click="resetAndFetch"
                class="inline-flex items-center rounded-lg bg-indigo-500 px-4 py-2 text-sm font-semibold text-white shadow hover:bg-indigo-400 transition duration-150"
            >
                Filtrar
            </button>
        </div>

        <table-component
            :loading="loading"
            :headers="[]"
            :pagination="pagination"
            v-model="pagination"
            @fetch="fetch"
        >
            <template v-slot:thead>
                <thead class="dark:text-white">
                    <tr>
                        <th
                            v-for="header in headers"
                            :key="header"
                            scope="col"
                            class="p-3 text-left text-sm font-medium"
                        >
                            {{ header }}
                        </th>
                    </tr>
                </thead>
            </template>

            <tr v-for="item in items" :key="item.user.id">
                <td class="table-cell">
                    <div>
                        <a :href="`/user/${item.user.id}/plates`" target="_blank" class="hover:underline">
                            <p class="font-semibold">{{ item.user.name }}</p>
                            <p class="text-xs text-gray-500">{{ item.user.email }}</p>
                        </a>
                    </div>
                </td>
                <td class="table-cell">
                    {{ item.manager?.name ?? '—' }}
                </td>
                <td class="table-cell">
                    <span v-if="item.current_level" class="font-semibold">
                        {{ item.current_level.label }}
                        <small>({{ formatCurrency(item.current_level.amount) }})</small>
                    </span>
                    <span v-else class="text-gray-400">Sem nível</span>
                </td>
                <td class="table-cell">
                    <span v-if="item.next_level" class="font-semibold text-indigo-600 dark:text-indigo-400">
                        {{ item.next_level.label }}
                        <small>({{ formatCurrency(item.next_level.amount) }})</small>
                    </span>
                    <span v-else class="text-gray-400">Nível máximo atingido</span>
                </td>
            </tr>
        </table-component>
    </div>
</template>

<script>
import TableComponent from "../../components/layouts/table/TableComponent.vue";
import { useToast } from "vue-toastification";

export default {
    components: {
        TableComponent,
    },

    setup() {
        const toast = useToast();
        return { toast };
    },

    data() {
        return {
            items: [],
            managers: [],
            loading: false,
            headers: ["Produtor", "Gerente", "Nível Atual", "Próxima Placa"],
            filters: {
                search: null,
                manager_uuid: null,
            },
            pagination: {
                total: 0,
                per_page: 15,
                current_page: 1,
                last_page: 1,
                from: 1,
                to: 1,
            },
        };
    },

    computed: {
        formatCurrency() {
            return (value) => {
                return new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(value / 100);
            };
        },
    },

    mounted() {
        this.fetch();
        this.fetchManagers();
    },

    methods: {
        resetAndFetch() {
            this.pagination.current_page = 1;
            this.fetch();
        },

        fetch() {
            this.loading = true;
            this.items = [];

            axios
                .get("/api/account-portfolio/next-plate", {
                    params: {
                        page: this.pagination.current_page,
                        per_page: this.pagination.per_page,
                        search: this.filters.search,
                        manager_uuid: this.filters.manager_uuid,
                    },
                })
                .then(({ data }) => {
                    this.items = data.data;
                    this.pagination = {
                        total: data.total,
                        per_page: data.per_page,
                        current_page: data.current_page,
                        last_page: data.last_page,
                        from: data.from,
                        to: data.to,
                    };
                })
                .catch(({ response }) => {
                    this.toast.error(response?.data?.message ?? "Erro ao carregar dados");
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        fetchManagers() {
            axios
                .get("/api/account-portfolio/managers")
                .then(({ data }) => {
                    this.managers = data;
                })
                .catch(() => {});
        },
    },
};
</script>
